import React from 'react';
import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';

const list = [
    {
        img: '/images/svg/rec/complex/1.svg',
        title: 'Поиск экспортеров',
        desc: '<p>Найти предпринимателя, который занимается несырьевым экспортом или только прощупывает почву для открытия своего бизнеса — задача не из легких.</p><p>При поиске ЦА для РЭЦ мы столкнулись с несколькими трудностями:</p>',
        complexList: [
            {
                name: '01. Прямые ключевые фразы',
                desc: 'В контекстной рекламе по ключевой фразе не всегда можно квалифицировать нужного пользователя. По общим направлениям и направлениям без четко сформированного спроса в рекламных кампаниях сложно выделить прямые ключевые фразы, которые может искать ЦА.',
            },
            {
                name: '02. Поиск целевой аудитории',
                desc: 'При подборе аудитории в Facebook и myTarget сложно выйти на нужную ЦА, а после первого контакта поддерживать интерес. В процессе поиска аудиторий мы постоянно тестируем разные гипотезы, а для поддержки интереса обновляем креативы. После нескольких итераций сделали ставку больше на каскадный ретаргетинг и работу с существующей аудиторий в целом.',
            },
            {
                name: '03. Генерация идей',
                desc: 'Аудитория любого канала продвижения быстро изживает себя. Это требует новых идей для выхода на ЦА — новые гипотезы тестирования, расширение семантики.',
            },
            {
                name: '04. Тематика',
                desc: 'Несырьевой экспорт — специфичная тематика для SEO-оптимизации, так как за ТОП в поисковой выдаче приходилось соперничать с большими агрегаторами и информационными порталами.',
            },
        ],
    },
    {
        img: '/images/svg/rec/complex/2.svg',
        title: 'Семантика',
        desc: '<p>Это был большой объем семантики, который требовал тщательной обработки еще на этапе создания рекламной компании.</p>',
        complexList: [
            {
                name: 'Сбор ключевых слов',
                desc: 'На старте было собрано порядка 2 тысяч ключевых слов, после дополнительной проработки мы стали на постоянной основе работать с семантикой в 6 тысяч ключей. Последующий анализ и корректировки сопряжены с обработкой больших объемов данных. Как следствие — усложняет мониторинг, процесс аналитики и принятия решения.',
            },
        ],
    },
];

const Complex = () => {
    return (
        <ScrollAnimation delay={0} animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper className="complex-rec" bigPaddings={true} isMargin={false}>
                <CommonTitle className="complex-rec__title">Сложности</CommonTitle>
                {list.map(({ complexList, title, desc, img }, index) => (
                    <ScrollAnimation
                        className="complex-rec__wrapper"
                        delay={0}
                        animateIn="fadeInUp"
                        offset={0}
                        animateOnce={true}
                        duration={1}
                        key={index}
                    >
                        <div className="complex-rec__icon">
                            <img src={img} alt={title} loading="lazy" />
                        </div>
                        <div className="complex-rec__grid">
                            <div className="complex-rec__item complex-rec__item--left">
                                <div
                                    className="complex-rec__name"
                                    dangerouslySetInnerHTML={{ __html: title }}
                                />
                                <div
                                    className="complex-rec__desc"
                                    dangerouslySetInnerHTML={{ __html: desc }}
                                />
                            </div>
                            <div className="complex-rec__item complex-rec__item--right">
                                {complexList.map(({ name, desc }, index) => (
                                    <ScrollAnimation
                                        className="complex-rec__row"
                                        delay={100}
                                        animateIn="fadeInUp"
                                        offset={50}
                                        animateOnce={true}
                                        duration={1}
                                        key={index}
                                    >
                                        <div
                                            className="complex-rec__row-name"
                                            dangerouslySetInnerHTML={{ __html: name }}
                                        />
                                        <div
                                            className="complex-rec__row-desc"
                                            dangerouslySetInnerHTML={{ __html: desc }}
                                        />
                                    </ScrollAnimation>
                                ))}
                            </div>
                        </div>
                    </ScrollAnimation>
                ))}
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Complex;
